// Shared inline-style tokens for the whole vendor recipient portal (unauthenticated + portal-
// authenticated pages alike). Deliberately a small local copy rather than importing
// ../Vendors/VendorDetails.tsx's `T`/`sans` -- those are meant for the authenticated tenant app
// shell, not a page an external recipient with no FluxWatch tenant account will ever see.
//
// The original keys keep their original values: AnswerQuestionnaire.tsx (the answering page) reads
// them too and is deliberately left as it is. Newer keys below were added for the portal redesign.
export const T = {
  ink: '#0F172A', muted: '#64748B', faint: '#94A3B8', bg: '#F5F6FA', surface: '#FFFFFF',
  surface2: '#F8FAFC', bdr: '#E2E8F0', blue: '#3B82F6', blueBg: '#EFF6FF', red: '#DC2626', green: '#059669',

  ink2: '#1E293B', slate: '#475569', bdrStrong: '#CBD5E1', hover: '#F1F5F9',
  primary: '#2563EB', primaryHover: '#1D4ED8',
  greenBg: '#ECFDF5', greenBdr: '#A7F3D0',
  amber: '#B45309', amberBg: '#FFFBEB', amberBdr: '#FDE68A',
  redBg: '#FEF2F2', redBdr: '#FECACA',
  violet: '#7C3AED', violetBg: '#F5F3FF',
  panel: '#0F172A',
};

export const sans = "'Inter', system-ui, sans-serif";
